export default __webpack_public_path__ + "static/media/parkeasy3.5f19e4f6.png";